export const FETCH_SESIONES_REQUEST = "FETCH_SESIONES_REQUEST";
export const FETCH_SESIONES_SUCCESS = "FETCH_SESIONES_SUCCESS";
export const FETCH_SESIONES_FAILURE = "FETCH_SESIONES_FAILURE";

export const FETCH_SESION_ONE_SUCCESS = "FETCH_SESION_ONE_SUCCESS";
export const FETCH_SESION_ONE_FAILURE = "FETCH_SESION_ONE_FAILURE";
